var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "movie-banner_inner" },
    [
      _c(
        "el-carousel",
        {
          class: _vm.value.config.value.length < 2 && "hideDot",
          attrs: {
            trigger: "click",
            "initial-index": 1,
            height: _vm.imgHeight + "rem",
            arrow: _vm.value.config.value.length < 2 ? "never" : "hover",
          },
        },
        _vm._l(_vm.value.config.value, function (item, index) {
          return _c("el-carousel-item", { key: index }, [
            _c(
              "div",
              {
                class: ["banner-img", !item.imageurl && "err"],
                style: { backgroundImage: "url(" + item.imageurl + ")" },
              },
              [
                !item.imageurl
                  ? _c("i", { staticClass: "el-icon el-icon-picture" })
                  : _vm._e(),
              ]
            ),
          ])
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }